var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22V17.8C21 16.2536 22.2536 15 23.8 15H26.2C27.7464 15 29 16.2536 29 17.8V22",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.261C17 23.7367 18.1431 22.4547 19.6574 22.2806L24.6574 21.7059C24.8851 21.6797 25.1149 21.6797 25.3426 21.7059L30.3426 22.2806C31.8569 22.4547 33 23.7367 33 25.261V31.0935C33 32.5537 31.9487 33.8018 30.5097 34.0499L25.5097 34.912C25.1724 34.9701 24.8276 34.9701 24.4903 34.912L19.4903 34.0499C18.0513 33.8018 17 32.5537 17 31.0935V25.261Z",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27.2224,
    r: 1.11111,
    fill: "#CA1211",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.3335V30.5557",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.0693a42f4afc657af5c52f3c81383ac0.svg";
export { ForwardRef as ReactComponent };